"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLocaleBooleanComponentParameters = void 0;
// PARAMETER ARRAY
exports.UserLocaleBooleanComponentParameters = [
    {
        id: 'true_label',
        label: 'True Label (Locale)',
        description: 'Input Param - The localized label for the true boolean value',
        type: 'json_object',
        paramType: 'STRING_RES',
        renderer: 'localized-string',
        required: false,
    },
    {
        id: 'false_label',
        label: 'False Label (Locale)',
        description: 'Input Param - The localized label for the false boolean value',
        type: 'json_object',
        paramType: 'STRING_RES',
        renderer: 'localized-string',
        required: false,
    },
    {
        id: 'selected',
        label: 'Selected Value',
        description: 'Output Param - The boolean value selected by user',
        type: 'output',
        paramType: 'BOOLEAN',
        required: true,
    },
];
//# sourceMappingURL=UserLocaleBooleanComponent.js.map